import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { estimateNormApplyService } from '../services/estimateNormApply.service';
import { useAuth } from '@/core/auth/AuthContext';
import type { EstimateItem } from '../types/estimate.types';
import type { EstimateNormInput, EstimateNormResourceInput } from '../types/estimateNorms.types';
import { toast } from 'sonner';

export function useEstimateNorms(companyId?: string, categoryCode?: string) {
  return useQuery({
    queryKey: ['estimate-norms', companyId, categoryCode],
    queryFn: () => estimateNormApplyService.getNorms(companyId!, categoryCode),
    enabled: !!companyId,
  });
}

export function useEstimateNormDetail(normId?: string) {
  return useQuery({
    queryKey: ['estimate-norms', 'detail', normId],
    queryFn: () => estimateNormApplyService.getNormById(normId!),
    enabled: !!normId,
  });
}

export function useCreateEstimateNorm() {
  const queryClient = useQueryClient();
  const { profile } = useAuth();

  return useMutation({
    mutationFn: ({ input, resources }: { input: EstimateNormInput; resources: EstimateNormResourceInput[] }) =>
      estimateNormApplyService.createNorm(profile?.id || '', input, resources),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['estimate-norms'] });
      toast.success('Đã tạo định mức');
    },
    onError: (error: any) => toast.error(error?.message || 'Không tạo được định mức'),
  });
}

export function useApplyNormToItem() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ item, normId }: { item: EstimateItem; normId: string }) => 
      estimateNormApplyService.applyNormToItem(item, normId),
    onSuccess: (_, { item }) => {
      queryClient.invalidateQueries({ queryKey: ['estimates', 'resources', item.estimate_id] });
      toast.success('Áp định mức thành công');
    },
    onError: (error) => {
      console.error(error);
      toast.error('Lỗi khi áp định mức');
    },
  });
}
